export enum AGENT_HUB {
    /**
     * @value Agent successfully deleted
     * @description Notification displayed when an agent has been deleted
     */
    AGENT_DELETED = 'AGENT_HUB.AGENT_DELETED',
    /**
     * @value Agent Name
     */
    AGENT_NAME = 'AGENT_HUB.AGENT_NAME',
    /**
     * @value Example: IT Support
     */
    AGENT_NAME_PLACEHOLDER = 'AGENT_HUB.AGENT_NAME_PLACEHOLDER',
    /**
     * @value Agent published
     */
    AGENT_PUBLISHED = 'AGENT_HUB.AGENT_PUBLISHED',
    /**
     * @value Agent saved as draft
     */
    AGENT_SAVED_AS_DRAFT = 'AGENT_HUB.AGENT_SAVED_AS_DRAFT',
    /**
     * @value Agent Studio
     * @description "Agent studio" feature translation key
     */
    AGENT_STUDIO = 'AGENT_HUB.AGENT_STUDIO',
    /**
     * @value This setting locks after publishing and cannot be changed/edited later.
     */
    AGENT_TYPE_HELPER = 'AGENT_HUB.AGENT_TYPE_HELPER',
    /**
     * @value AI Agent
     * @description Title for the React Stateless agent type option in the agent creation form.
     */
    AI_AGENT = 'AGENT_HUB.AI_AGENT',
    /**
     * @value Accessible via AI chat to perform actions, using internal and/or external tools
     * @description Description text for the React Stateless agent type option, explaining  its capabilities with tools.
     */
    AI_AGENT_DESCRIPTION = 'AGENT_HUB.AI_AGENT_DESCRIPTION',
    /**
     * @value Ask AI Audience
     * @description Back office side navigation entry
     */
    ASK_AI_AUDIENCE = 'AGENT_HUB.ASK_AI_AUDIENCE',
    /**
     * @value Choose who will have access to this agent in the Agent chat or Agent Library.
     */
    AUDIENCE_DESCRIPTION = 'AGENT_HUB.AUDIENCE_DESCRIPTION',
    /**
     * @value Select users or groups
     */
    AUDIENCE_PLACEHOLDER = 'AGENT_HUB.AUDIENCE_PLACEHOLDER',
    /**
     * @value Automatic
     */
    AUTOMATIC_OPTION = 'FRONT.SETTINGS.SELECTION_LIST',
    /**
     * @value Deleting the %TITLE% agent is irreversible. You will delete the entire configuration.
     * @description Message shown to users when they try to delete an agent.
     */
    CONFIRM_DELETE_AGENT = 'AGENT_HUB.CONFIRM_DELETE_AGENT',
    /**
     * @value Delete agent
     */
    DELETE_AGENT = 'AGENT_HUB.DELETE_AGENT',
    /**
     * @value Edit agent
     * @description Action displayed both as title when editing agents and trigger button to edit an agent.
     */
    EDIT_AGENT = 'AGENT_HUB.EDIT_AGENT',
    /**
     * @value Expertise
     */
    EXPERTISE = 'AGENT_HUB_SEARCH.EXPERTISE',
    /**
     * @value Describe what this agent knows. This helps users understand when to use it and helps the system route questions to the right agent.
     */
    EXPERTISE_DESCRIPTION = 'AGENT_HUB.EXPERTISE_DESCRIPTION',
    /**
     * @value Be specific. Clear keywords help the system match user questions to this agent.
     */
    EXPERTISE_HELPER = 'AGENT_HUB.EXPERTISE_HELPER',
    /**
     * @value What topics does this agent handle?
     */
    EXPERTISE_LABEL = 'AGENT_HUB.EXPERTISE_LABEL',
    /**
     * @value Example: IT support, password resets, device setup, VPN access, and software troubleshooting.
     */
    EXPERTISE_PLACEHOLDER = 'AGENT_HUB.EXPERTISE_PLACEHOLDER',
    /**
     * @value External Agent
     * @description Short label for the external agent type, shown as the "Type" in the agent admin list.
     */
    EXTERNAL_AGENT = 'AGENT_HUB.EXTERNAL_AGENT',
    /**
     * @value Instructions
     */
    INSTRUCTIONS = 'AGENT_HUB_SEARCH.INSTRUCTIONS',
    /**
     * @value Define how the agent should behave and respond to users. This acts as the system prompt for the AI, determining its tone, style, and formatting rules.
     */
    INSTRUCTIONS_DESCRIPTION = 'AGENT_HUB.INSTRUCTIONS_DESCRIPTION',
    /**
     * @value Your agent will also follow your workspace’s Global Guidelines (set by admins). They’re automatically appended to the instructions you write here when the agent runs.
     * @description Description displayed under the agent instructions field
     */
    INSTRUCTIONS_FIELD_HELPER = 'AGENT_HUB.INSTRUCTIONS_FIELD_HELPER',
    /**
     * @value Tips for writing good instructions:
     */
    INSTRUCTION_TIPS = 'AGENT_HUB.INSTRUCTION_TIPS',
    /**
     * @value Include rules about what the agent should not do.
     */
    INSTRUCTION_TIP_CONSTRAINTS = 'AGENT_HUB.INSTRUCTION_TIP_CONSTRAINTS',
    /**
     * @value Tell it how to respond (tone, format, length).
     */
    INSTRUCTION_TIP_RESPONSE = 'AGENT_HUB.INSTRUCTION_TIP_RESPONSE',
    /**
     * @value Give the agent a clear role (e.g., "You are an HR policy expert").
     */
    INSTRUCTION_TIP_ROLE = 'AGENT_HUB.INSTRUCTION_TIP_ROLE',
    /**
     * @value Select the sources this agent can use to answer questions.
     */
    KNOWLEDGE_HELPER = 'AGENT_HUB.KNOWLEDGE_HELPER',
    /**
     * @value {"one":"You can add up to %MAX_SOURCES% source. Manage sources in the Knowledge Sources page.","other":"You can add up to %MAX_SOURCES% sources. Manage sources in the Knowledge Sources page."}
     */
    KNOWLEDGE_MAX_SOURCES_HELPER = 'AGENT_HUB.KNOWLEDGE_MAX_SOURCES_HELPER',
    /**
     * @value Knowledge Sources
     */
    KNOWLEDGE_SOURCES = 'AGENT_HUB.KNOWLEDGE_SOURCES',
    /**
     * @value List an external Agent in the library
     * @description Title for the External agent type option in the agent creation form.
     */
    LIST_AN_EXTERNAL_AGENT_IN_THE_LIBRARY = 'AGENT_HUB.LIST_AN_EXTERNAL_AGENT_IN_THE_LIBRARY',
    /**
     * @value List your agent located in external systems
     * @description Description text for the External agent type option, explaining it lists agents from external systems.
     */
    LIST_AN_EXTERNAL_AGENT_IN_THE_LIBRARY_DESCRIPTION = 'AGENT_HUB.LIST_AN_EXTERNAL_AGENT_IN_THE_LIBRARY_DESCRIPTION',
    /**
     * @value New agent
     */
    NEW_AGENT = 'AGENT_HUB.NEW_AGENT',
    /**
     * @value Accessible via Search Result Page and AI Chat. Display a predefined response for specific search queries.
     */
    PROVIDE_CUSTOM_ANSWER_DESCRIPTION = 'AGENT_HUB.PROVIDE_CUSTOM_ANSWER_DESCRIPTION',
    /**
     * @value Set up the basics of your AI agent: what it's called, who can use it, and how it works.
     */
    SETUP_DESCRIPTION = 'AGENT_HUB.SETUP_DESCRIPTION',
    /**
     * @value Sources & Tools
     * @description Title of the combined Sources & Tools filter in the agent library.
     */
    SOURCES_AND_TOOLS = 'AGENT_HUB.SOURCES_AND_TOOLS',
    /**
     * @value Specialized Search Assistant for Ask AI
     * @description Title for the RAG agent type option in the agent creation form.
     */
    SPECIALIZED_SEARCH_ASSISTANT_FOR_ASK_AI = 'AGENT_HUB.SPECIALIZED_SEARCH_ASSISTANT_FOR_ASK_AI',
    /**
     * @value Accessible in the Search Result Page and AI Chat to provide custom answer based on your content
     * @description Description text for the RAG agent type option, explaining where and how this agent type is accessible.
     */
    SPECIALIZED_SEARCH_ASSISTANT_FOR_ASK_AI_DESCRIPTION = 'AGENT_HUB.SPECIALIZED_SEARCH_ASSISTANT_FOR_ASK_AI_DESCRIPTION',
    /**
     * @value Third party agent
     * @description Short type label shown in the agent admin list for external A2A (third-party) agents.
     */
    THIRD_PARTY_AGENT = 'AGENT_HUB.THIRD_PARTY_AGENT',
    /**
     * @value Tools
     * @description Title of the tools picker
     */
    TOOLS = 'AGENT_HUB.TOOLS',
    /**
     * @value Select the tools this agent can use to perform actions.
     */
    TOOLS_HELPER = 'AGENT_HUB.TOOLS_HELPER',
    /**
     * @value What do you want to build?
     * @description Label for the agent type selection section in the agent creation form.
     */
    WHAT_DO_YOU_WANT_TO_BUILD = 'AGENT_HUB.WHAT_DO_YOU_WANT_TO_BUILD',
}
